export default "__VITE_ASSET__D7RoMrKk__"